export default __webpack_public_path__ + "a28cc5864fc29de09fed5a91d388ad1c.wav";